import styled from 'styled-components';

export const NoDataContainer = styled.div`
	width: 100%;
	height: calc(100dvh - 80px);

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const NoSearchDataContainer = styled.div`
	width: 100%;
	height: calc(100dvh - 80px - 240px);

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const NoDataImg = styled.img`
	width: 116px;
	height: auto;
`;

export const NoSearchDataImg = styled.img`
	width: 116px;
	height: auto;
`;

export const Container = styled.div`
	width: 100%;
	padding: 8px 20px;
	padding-top: 48px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	position: relative;
`;

export const Header = styled.div<{ isAllFolderPage: boolean }>`
	width: calc(100% + 40px);
	max-width: 768px;
	padding: 12px 16px;
	margin-top: -48px;

	display: flex;
	justify-content: space-between;
	align-items: center;

	position: sticky;
	top: ${({ isAllFolderPage }) => (isAllFolderPage ? '65px' : '48px')};
	z-index: 100;
	margin-left: -20px;

	background-color: white;
`;

export const FontHighlight = styled.span`
	color: ${({ theme }) => theme['orange-primary']};
`;

export const EditModeButton = styled.div`
	padding: 4px 0px;

	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
`;

export const SearchBarWrapper = styled.div`
	width: 100%;
	padding: 10px 0px;
`;

export const OrderedButtonContainer = styled.div`
	width: 100%;
`;

export const OrderedButton = styled.div`
	padding: 4px 6px;

	display: inline-flex;
	justify-content: flex-start;
	align-items: center;
	gap: 6px;

	svg {
		width: 14px;
		height: 12px;
	}
`;

export const SearchContainer = styled.div`
	width: 100%;
	height: calc(100dvh - 90px - 180px);

	img {
		width: 150px;
	}

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;
